import CreateWorkByFileUploadLayout from '@Scenes/WorkScenes/CreateWorkByFileUploadLayout'
import FileUploadStep from '@Scenes/WorkScenes/Steps/FileUploadStep'
import FileReviewStep from '@Scenes/WorkScenes/Steps/FileReviewStep'
import SubmissionBulkStep from '@Scenes/WorkScenes/Steps/SubmissionBulkStep'
import React from 'react'
import Navigation from '@App/navigation'
import createEditWorkRoutes from '@App/routes/rightsholder/editwork'
import { PERMISSIONS } from '@Const/permissions'
import PermissionCheck from '@Components/Utility/PermissionCheck'
import { BULK_ROUTES, EDIT_ROUTE } from '@App/navigation/route'

const createCreateWorkByBulkRoutes = () => {
    const editWorkRoutes = createEditWorkRoutes(EDIT_ROUTE)
    return {
        path: BULK_ROUTES.root,
        element: (
            <PermissionCheck
                requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.view_works]}
                orIsInternal
                reRouteLocation={Navigation.home.root()}
            >
                <CreateWorkByFileUploadLayout />
            </PermissionCheck>
        ),
        children: [
            {
                path: BULK_ROUTES.fileUpload,
                element: <FileUploadStep />,
            },
            {
                path: BULK_ROUTES.fileReview,
                element: <FileReviewStep />,
            },
            {
                path: BULK_ROUTES.submission,
                element: <SubmissionBulkStep />,
            },
            editWorkRoutes,
            {
                path: '',
                element: <FileUploadStep />,
            },
        ],
    }
}

export default createCreateWorkByBulkRoutes
